import { PlanType } from "@brookbush/database";

import clsx from "clsx";

import useStripePrices from "~/hooks/useStripePrices";
import { getPaywallPriceLine } from "~/lib/paywall-price";
import { getAmountIndividual } from "~/lib/stripe/helpers";

interface PaywallPriceLineTextProps {
	className?: string;
}

const PaywallPriceLineText = ({ className }: PaywallPriceLineTextProps) => {
	const { prices } = useStripePrices(PlanType.INDIVIDUAL);

	const yearlyPrice = prices?.find(
		(price) => price.recurring?.interval === "year",
	);
	const line = yearlyPrice
		? getPaywallPriceLine({
				yearlyAmount: getAmountIndividual(yearlyPrice),
				currency: yearlyPrice.currency,
			})
		: null;

	if (!line) return null;

	return <p className={clsx("font-medium", className)}>{line}</p>;
};

export default PaywallPriceLineText;
